/**
 * Language Interceptor - Multi-language Support
 * Adds Accept-Language header to all requests
 */

import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../services/providers/storage/localstorage.service';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  private readonly LANGUAGE_KEY = 'user_language';

  constructor(private storage: LocalStorageService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Get current language (default: 'fr')
    const language = this.storage.getItem(this.LANGUAGE_KEY) || 'fr';

    // Add Accept-Language header
    const clonedRequest = request.clone({
      setHeaders: {
        'Accept-Language': language
      }
    });

    return next.handle(clonedRequest);
  }
}

